<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
  >
    <path
      d="M4.017 16.841C4.1727 16.9973 4.292 17.186 4.36641 17.3937C4.44082 17.6014 4.46851 17.8229 4.4475 18.0425C4.34208 19.0589 4.14221 20.0632 3.8505 21.0425C5.943 20.558 7.221 19.997 7.8015 19.703C8.13076 19.5362 8.50993 19.4967 8.8665 19.592C9.88865 19.8645 10.9421 20.0017 12 20C17.994 20 22.5 15.7895 22.5 11C22.5 6.212 17.994 2 12 2C6.006 2 1.5 6.212 1.5 11C1.5 13.202 2.4255 15.245 4.017 16.841ZM3.2775 22.6985C2.9221 22.769 2.56555 22.8335 2.208 22.892C1.908 22.94 1.68 22.628 1.7985 22.349C1.93169 22.0349 2.05376 21.7162 2.1645 21.3935L2.169 21.3785C2.541 20.2985 2.844 19.0565 2.955 17.9C1.1145 16.055 0 13.64 0 11C0 5.201 5.373 0.5 12 0.5C18.627 0.5 24 5.201 24 11C24 16.799 18.627 21.5 12 21.5C10.8115 21.5016 9.62788 21.3473 8.4795 21.041C7.6995 21.4355 6.021 22.154 3.2775 22.6985Z"
      fill="#213e7a"
    />
  </svg>
</template>

<script>
export default {
  name: "IconComment",
};
</script>

<style></style>
